// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { PurchaseOrder, purchaseOrderSchema } from '@/purchase-order/api/types';
import { z } from 'zod';

/**
 * Schema for validating the response from the send purchase order to 3PL API endpoint.
 */
const sendPurchaseOrderTo3PLResponseSchema = z.object({
  data: purchaseOrderSchema,
  metadata: responseMetadataSchema,
});

/**
 * Sends a purchase order to a third-party logistics provider for receiving.
 *
 * @param purchaseOrderKey - The key of the purchase order to send to 3PL
 * @returns The updated purchase order with thirdParty.isEnabled=true and status=awaiting_3pl
 */
export async function sendPurchaseOrderTo3PL(
  purchaseOrderKey: string
): Promise<PurchaseOrder> {
  const url = `/v1/purchase-order/${purchaseOrderKey}/send-to-3pl`;
  const response = await api.post(url);

  const { data } = await parseResponse(
    sendPurchaseOrderTo3PLResponseSchema,
    response.data,
    {
      schemaName: 'SendPurchaseOrderTo3PL',
      endpoint: url,
    }
  );
  return data;
}
